"use strict";

const techpadOptionPrefixKey = "TechpadOptions::";

export class TechpadOptions {
  static $inject = ["localStorage", "authService", "WorklistUserSettings"];

  constructor(localStorage, authService, WorklistUserSettings) {
    this.localStorage = localStorage;
    this.authService = authService;
    this.WorklistUserSettings = WorklistUserSettings;
    this.options = null;
    this.currentUserName = "";
    this.getOptions();
  }

  init() {
    this.getOptions();
    this.checkAndApplyDarkMod();
  }

  getOptions() {
    if (
      this.options === null ||
      this.currentUserName !== this.authService.getUserName()
    ) {
      this.currentUserName = this.authService.getUserName();
    }
    try {
      this.options = this.localStorage.getObject(
        techpadOptionPrefixKey + this.currentUserName
      );
    } catch (err) {
      this.options = {};
    }
    return this.options;
  }

  saveOptions() {
    this.localStorage.setObject(
      techpadOptionPrefixKey + this.currentUserName,
      this.options
    );

    this.WorklistUserSettings.saveUsersSettings(this.options);
  }

  checkAndApplyDarkMod() {
    if (this.options.DarkMode && !$("body").hasClass("dark-mode")) {
      $("body").addClass("dark-mode");
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/techpadOptions.js